module.exports = __webpack_public_path__ + "pc/img/banner.6cf458a7.png";